meedy.factory('meedy.videoConsultationService', ['$q', '$http', '$rootScope', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $http, $rootScope, baseService, objectHelper, config) {

        function VideoConsultationService() {

            this.beginVideoConsultation = function(wrapper) {
                return baseService.post(config.API_URL + '/streaming/begin', wrapper).then(
                    function (successResponse) {
                        return $q.resolve(successResponse);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.endVideoConsultation = function(wrapper) {
                return baseService.post(config.API_URL + '/streaming/end', wrapper).then(
                    function (successResponse) {
                        return $q.resolve(successResponse);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.sendACKStatus = function(wrapper) {
                return baseService.post(config.API_URL + '/streaming/online', wrapper).then(
                    function (successResponse) {
                        return $q.resolve(successResponse);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.sendACKFreeStatus = function(wrapper) {
                return baseService.post(config.API_URL + '/streaming/web/status', wrapper).then(
                    function (successResponse) {
                        return $q.resolve(successResponse);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.streamingDetails = function(idTerm) {
                return baseService.get(config.API_URL + '/terms/' + idTerm + '/streamingDetails').then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, StreamingConnectionDetailsVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.sendAudioBlob = function (idOrder, timestamp, blob) {

                var formData = new FormData();
                formData.append('file', blob);

                $rootScope.ignoreError.push(config.API_URL + '/upload/onlineConsultation/order/' + idOrder + '/timestamp/' + timestamp);

                var req = {
                    method: 'POST',
                    url: config.API_URL + '/upload/onlineConsultation/order/' + idOrder + '/timestamp/' + timestamp,
                    headers: { 'Content-Type': undefined },
                    data: formData
                };

                return $http(req).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );

            };
        }

        return new VideoConsultationService();
    }
]);
